import { compose, hoistStatics, withHandlers, lifecycle, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import License from './License';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/license.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';

const defaultFormData = {
  type: 1,
  status: 1,
  name: '',
  description: '',
  price_monthly: '',
  price_yearly: '',
  price_single: '',
  token_value: '',
  ml: {},
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
    },
  }),
  withProps(props => ({
    title: props.t('License') + fh.getTitleEnd(props),
    types: ModelService.getTypesOptions(props.t),
    statuses: ModelService.getStatusesOptions(props.t),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeMl: fh.onChangeFormDataMlElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(License, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/licenses/license/index.js